// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__vJsl6","title":"AfterFrontImage_title__1jVjs"};